import { DataProvider } from 'react-admin'
import { RoleDto } from '../../dto/role/role.dto'

const fakeRoles: RoleDto[] = []

const provider = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getList: (resource, params) =>
    Promise.resolve({ data: fakeRoles, total: fakeRoles.length }),
} as DataProvider

export default provider
